import useViewYTVideo from "../hooks/main/useViewDocumentModal";
import Modal from "./Modal";

const ViewYTVideo = () => {
  const { isOpen, close, url, label } = useViewYTVideo();

  if (!url) return null;

  const content = (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-full max-w-7xl aspect-video">
        <iframe
          src={url}
          title={label}
          className="w-full h-full rounded-2xl shadow-lg"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      close={close}
      label={label}
      content={content}
    />
  );
};

export default ViewYTVideo;
